import React from "react";
import { PublicLayout, PageContainer, PageHeader } from "@/components/PublicLayout";
import { useSeo } from "@/lib/useSeo";
import { ShieldCheck, Clock, Archive, Info } from "@phosphor-icons/react";

const FEATURES = [
  { Icon: Clock, title: "Daily Updates", text: "First Round (10:30 AM) and Second Round (11:30 AM) results updated every day in IST." },
  { Icon: Archive, title: "Complete Archive", text: "A clean, searchable history of past results organized by date." },
  { Icon: ShieldCheck, title: "Informational Only", text: "We provide reference information — no betting, no payments, no predictions." },
  { Icon: Info, title: "Simple & Fast", text: "A mobile-first, fast-loading experience built for clarity." },
];

export default function About() {
  useSeo({ title: "About Guwahati Morning Teer | Morning Teer Guwahati", description: "About Guwahati Morning Teer - a fast, informational daily Morning Teer results and archive website. First Round 10:30 AM, Second Round 11:30 AM.", path: "/about" });
  return (
    <PublicLayout>
      <PageContainer className="py-10 max-w-3xl">
        <PageHeader eyebrow="Who We Are" title="About Us" />
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-700 leading-relaxed text-lg">
            <strong>Guwahati Morning Teer</strong> is an informational website dedicated to
            publishing daily Morning Teer results and maintaining an organized archive for easy
            reference.
          </p>
          <p className="text-slate-600 leading-relaxed">
            Our goal is to offer a clean, trustworthy and fast place to check the day's First Round
            and Second Round numbers, browse previous results, and explore historical data. All
            times and dates are presented in India Standard Time (Asia/Kolkata) so every visitor
            sees the same information.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 mt-8">
          {FEATURES.map(({ Icon, title, text }, i) => (
            <div key={i} className="rounded-2xl bg-white border border-slate-100 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] p-5" data-testid={`about-feature-${i}`}>
              <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-brand-light text-brand mb-3">
                <Icon className="w-6 h-6" weight="duotone" />
              </span>
              <h3 className="font-heading font-bold text-slate-900">{title}</h3>
              <p className="text-sm text-slate-500 mt-1 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl bg-brand-900 text-white p-6">
          <h3 className="font-heading font-bold text-lg">Important Notice</h3>
          <p className="text-violet-200 text-sm mt-2 leading-relaxed">
            This website does not facilitate betting, gambling, transactions, or payments of any
            kind, and does not provide predictions or recommendations. All content is strictly for
            informational and archival purposes.
          </p>
        </div>
      </PageContainer>
    </PublicLayout>
  );
}
